export const SET_SELECTED_GPT_CHAT = "SET_SELECTED_GPT_CHAT";
export const SET_CHAT_GROUP = "SET_CHAT_GROUP";
export const SET_CHATS_CONVERSATION = "SET_CHATS_CONVERSATION";
export const SET_ADD_CHAT = "SET_ADD_CHAT";
export const SET_FOLLOW_UP_QUESTION = "SET_FOLLOW_UP_QUESTION";
